
const useFormFields = () => {

    const fields = [
        {
            name: "name",
            component: "input",
            placeholder: "שם ",
        }
    ]

    return fields
}

export default useFormFields